export default __webpack_public_path__ + "static/media/6.35180e2e.jpg";